import { sha512 } from '@noble/hashes/sha512';

const parents = new WeakMap();
function getContainer(selector) {
    return document.querySelector(selector) ?? document.head;
}
function insertStyleTag(parent, insertPosition, attributes) {
    const el = document.createElement('style');
    el.setAttribute('type', 'text/css');
    Object.entries(attributes).forEach(([key, value]) => el.setAttribute(key, value));
    parent.insertAdjacentElement(insertPosition, el);
    return el;
}
function insertHashedStyleTag(style, parent, insertPosition, attributes) {
    const id = `sha512:${globalThis.btoa(String.fromCharCode(...sha512(style)))}`;
    if (globalThis.document.getElementById(id))
        return;
    return insertStyleTag(parent, insertPosition, { ...attributes, id });
}
function insertStyleTagSingle(parent, insertPosition, attributes) {
    if (!parents.has(parent))
        parents.set(parent, {});
    const positions = parents.get(parent);
    const el = positions[insertPosition];
    if (el)
        return el;
    const newEl = insertStyleTag(parent, insertPosition, attributes);
    positions[insertPosition] = newEl;
    return newEl;
}
function normalizeCss(css) {
    // strip potential UTF-8 BOM if css was read from a file
    return css.charCodeAt(0) === 0xfeff ? css.substring(1) : css;
}
/**
 * @param {string} css
 * @param {object} options
 */
function injectCss(css, { singleTag = false, prepend = false, container: selector = 'head', attributes = {}, } = {}) {
    if (!css || typeof globalThis.document === 'undefined')
        return;
    const insertPosition = prepend ? 'afterbegin' : 'beforeend';
    const parent = getContainer(selector);
    const value = normalizeCss(css);
    const styleTag = singleTag
        ? insertStyleTagSingle(parent, insertPosition, attributes)
        : insertHashedStyleTag(value, parent, insertPosition, attributes);
    if (styleTag)
        styleTag.appendChild(globalThis.document.createTextNode(value));
}

export { injectCss as default };
//# sourceMappingURL=injectCss.mjs.map
